export var modalModule = {
    state: {
        isModalOpen: false,
        lastFocusedElement: null,
    },
    mutations: {
        toggleModal: function (state, isOpen) {
            state.isModalOpen = isOpen;
        },
        setLastFocusedElement: function (state, element) {
            state.lastFocusedElement = element;
        },
        resetLastFocusedElement: function (state) {
            state.lastFocusedElement = null;
        },
    }
};
